/* eslint-disable */
import React, { Component } from 'react'; 
import HTMLText from '../UiComponent/HTMLText';
import  './FormPage.scss'
import CheckBox from '../UiComponent/CheckBox'
import { Fragment } from 'react/cjs/react-jsx-runtime.production.min';
import RadioButton from '../UiComponent/RadioButton';

class RaceCheckBoxSelect extends Component {
	constructor(props) {
		super(props);	
		this.state = {
			race:this.props.raceInfo,
			maxRace:this.props.maxRace,
			parent:this.props.parent,
			selectedList:this.props.selectedList || [],
			fMsg:this.props.wording,
			skaterYear:this.props.skaterYear,
			skaterGender:this.props.skaterGender,
			optField:this.props.optField,
			eventInfo:this.props.eventInfo,
			shownList:[]
			
		};	
	}

    componentWillReceiveProps(nextProps) {	
	
		this.setState({race:nextProps.raceInfo,maxRace:nextProps.maxRace,selectedList:nextProps.selectedList || [],
			fMsg:nextProps.wording,skaterYear:nextProps.skaterYear,skaterGender:nextProps.skaterGender,shownList:[],optField:nextProps.optField});
	
		if (this.state.skaterYear != nextProps.skaterYear || this.state.skaterGender != nextProps.skaterGender){
			this.props.parent.setState({selectedList:[]});			
		}

		var newRaceArray = [];  
		this.setState({eventInfo:nextProps.eventInfo,optField:nextProps.optField})
		if (nextProps.raceInfo != null){
			
			nextProps.raceInfo.forEach(function(item) {
				if(item.minYear <= nextProps.skaterYear && item.maxYear >= nextProps.skaterYear &&
					(item.gender == null || item.gender == "" || item.gender== nextProps.skaterGender) && item.type == nextProps.type){
						
						newRaceArray.push(item);
					}
				},this);
			this.setState({shownList:newRaceArray});		
		}
	} 
	
	componentDidMount() {       
     
	}

	componentWillUnmount() {
	}    
    
	render() {	
		if (this.state.shownList && this.state.shownList.length >0){
			var raceDisplayList =this.state.shownList.map((item) =>
				<CheckBox className='race-item-checkbox' key={item.id} curValue={this.state.selectedList} dataField='selectedList' name='raceItem' parent={this.props.parent}
				text={item.nameZh +'<br/>' + item.nameEn} value={item.id} maxCheck={this.state.maxRace}/>
			)
		}else{
			var raceDisplayList = <HTMLText className='f4-font' text={this.state.fMsg.noRaceAvailZh +"<br/>" + this.state.fMsg.noRaceAvailEn}/>
		}
		if (this.state.eventInfo && this.state.eventInfo.optFieldDisplayLevel != null && this.state.eventInfo.optFieldOptionEn != null 
			&& this.state.eventInfo.optFieldOptionZh != null){
			var optFieldDisplayTypeArr = this.state.eventInfo.optFieldDisplayLevel && this.state.eventInfo.optFieldDisplayLevel.toUpperCase().split("|");		
			var displayOptField = false;
			const self = this;
			
			this.state.race.forEach(function(item) {
				self.state.selectedList.forEach(function(race){
					if (race == item.id){
						if (optFieldDisplayTypeArr.includes(item.level.toUpperCase())){
							displayOptField = true;
						}
					}
				})
			});		
			var optFieldOption = [];
			
			for(var i = 0; i< this.state.eventInfo.optFieldOptionEn.split("|").length;i++){
				optFieldOption.push({text: this.state.eventInfo.optFieldOptionZh.split("|")[i] + "<br/>" + this.state.eventInfo.optFieldOptionEn.split("|")[i], 
					value : this.state.eventInfo.optFieldOptionZh.split("|")[i] + " " + this.state.eventInfo.optFieldOptionEn.split("|")[i]})					
			}
		
		}

		return (
            <React.Fragment>						
								<tr className="row">
									<td>
										<HTMLText text={this.state.fMsg.raceItemTitleZh +":<span class='ast'></span><br/>" + this.state.fMsg.raceItemTitleEn+":<span class='ast'></span>"}/>
									</td>
									<td>
										{raceDisplayList}
									</td>
								</tr>     
									
								{displayOptField && 
								<Fragment>
									<tr className="row">
									<td>
										<HTMLText text={this.state.eventInfo.optFieldZh +"<br/>" + this.state.eventInfo.optFieldEn}/>
									</td>
									<td>
										  {this.state.eventInfo.optFieldType.toUpperCase() == 'R' && (
												<table className="optField-table">
													<tbody>
														<tr>
															{optFieldOption.map((option, index) => (
																<td>
																<RadioButton 
																	className='optField' 
																	name='optField'
																	value={option.value} 
																	parent={this.props.parent} 
																	dataField='optField' 
																	curValue={this.state.optField} 
																	text={option.text}
																/>
																</td>
														
															))}
														</tr>
													</tbody>
												</table>
											)}
											 {this.state.eventInfo.optFieldType.toUpperCase() == 'C' && (
												<table className="optField-table">
													<tbody>
														<tr>
															{optFieldOption.map((option, index) => (
																<td>
																<CheckBox 
																	className='optField' 
																	name='optField'
																	value={option.value} 
																	parent={this.props.parent} 
																	dataField='optField' 
																	curValue={this.state.optField?this.state.optField:""} 
																	text={option.text}
																/>
																</td>
														
															))}
														</tr>
													</tbody>
												</table>
											)}
									</td>
								</tr>  
								</Fragment>
								}	  												
            </React.Fragment>
		);
	}
}

export default RaceCheckBoxSelect;